import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import AddCoins from "../modals/AddCoins";
import EditUserModal from "../modals/EditUser";
import ShowSirRewards from "../modals/ShowSirRewards";
import moment from "moment";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import Footer from "../common/Footer";
import AdminUserSkeleton from "../../components/AdminUserSkeleton";
import OrgLogo from "../../assets/Organization.png";
import IndLogo from "../../assets/Individual.png";
import AdmLogo from "../../assets/Admin.png";
import { MdContentCopy } from "react-icons/md";
import { IoLogoWhatsapp } from "react-icons/io";
import { IoMail } from "react-icons/io5";

const Ngo = () => {
  const navigate = useNavigate();
  const { ngoId } = useParams();
  const [showSend, setShowSend] = useState(false);
  const openSend = () => setShowSend(true);
  const closeSend = () => setShowSend(false);
  const [showSirRewards, setShowSirRewards] = useState(false);
  const [totalSirRewards, setTotalSirRewards] = useState(0);
  const userToken = localStorage.getItem("userToken");
  const apiBase = (process.env.REACT_APP_LOCAL_API || "http://localhost:4200/auth/v1").replace(
    /\/auth\/v1\/?$/,
    ""
  );
  const [userData, setUserData] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const [currency, setCurrency] = useState({});
  const [filter, setFilter] = useState({ status: "", type: "" });
  const [sortByDate, setSortByDate] = useState("desc");
  const [profile, setProfile] = useState(localStorage.getItem("userRole") || "");
  const [isLoading, setIsLoading] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(0);
  const transactionsPerPage = 10;

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const indexOfLastTransaction = (currentPage + 1) * transactionsPerPage;
  const indexOfFirstTransaction = indexOfLastTransaction - transactionsPerPage;
  let currentTransactions = userData?.transactions?.slice(
    indexOfFirstTransaction,
    indexOfLastTransaction
  );

  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_LOCAL_API}/user`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        const profileType = response?.data?.user?.profileType;
        setProfile(profileType);
        if (profileType) {
          localStorage.setItem("userRole", profileType);
        }
      })
      .catch(() => {});
  }, [userToken]);

  const toggleSortByDate = () => {
    setSortByDate(sortByDate === "asc" ? "desc" : "asc");
  };

  const loadSirRewardTotal = () => {
    if (!ngoId || !userToken) return;
    axios
      .get(`${apiBase}/v2/reward/status/${ngoId}`, {
        headers: { Authorization: `Bearer ${userToken}` },
      })
      .then((response) => {
        setTotalSirRewards(response.data?.totalSirRewards || 0);
      })
      .catch(() => {
        setTotalSirRewards(0);
      });
  };

  const loadCoin = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_LOCAL_API}/currency`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        setCurrency(response.data[0]);
      })
      .catch(() => {});
  };

  const openModal = (user) => {
    setShowEdit(true);
  };

  const closeModal = () => {
    setShowEdit(false);
  };

  useEffect(() => {
    const loadData = () => {
      // Only show loading skeleton for filter changes, not initial load
      if (userData && Object.keys(userData).length > 0) {
        setIsDataLoading(true);
      }
      
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_LOCAL_API}/dashboard?transactionStatus=${filter.status}&transactionType=${filter.type}&userId=${ngoId}`,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };

      axios
        .request(config)
        .then((response) => {
          setUserData(response.data);
        })
        .catch((error) => {})
        .finally(() => {
          setIsDataLoading(false);
        });
    };
    loadCoin();
    loadData();
  }, [filter]);

  useEffect(() => {
    loadSirRewardTotal();
  }, [ngoId, userToken]);

  const sendBack = (val) => {
    Swal.fire({
      title: "Are you sure you want to reverse this transaction?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#3ca151",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_LOCAL_API}/revoke/${val._id}`,
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        };

        axios
          .request(config)
          .then((response) => {
            window.location.reload();
            setIsLoading(false);
          })
          .catch(() => {});
      } else {
      }
    });
  };

  const handleView = (user) => {
    // Use userName if available, otherwise fallback to _id
    const identifier = user?.userName || user?._id;
    if (identifier) {
      window.open(`/Community/${identifier}`);
    } else {
      console.error('No valid identifier found for user:', user);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(
      `https://demo.donor.money/register?referredby=${userData?.user?.referCode}`
    );
  };

  const handleMail = () => {
    window.open(
      `mailto:friend@example.com?subject=Donor Money Referral Link&body=Use my Referral link while creating Donor Money account: https://demo.donor.money/register?referredby=${userData?.user?.referCode}`
    );
  };

  const handleWp = () => {
    window.location.href = `https://wa.me/send?text= Use my Referral link while creating Donor Money account: https://demo.donor.money/register?referredby=${userData?.user?.referCode}`;
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  if (isDataLoading) {
    return (
      <>
        <AdminUserSkeleton />
        <Footer />
      </>
    );
  }

  return (
    <>
      <div className="user-dashboard-container">
        <div className="dashboard-header">
          <h1 className="dashboard-title">Dashboard - User View</h1>
        </div>

        {/* User Profile Section */}
        <div className="profile-section">
          <div className="profile-info">
            <div className="profile-avatar">
              <img
                className="profile-image"
                src={
                  userData?.user?.profilePic ||
                  (userData?.user?.profileType === "admin"
                    ? AdmLogo
                    : userData?.user?.profileType === "individual"
                    ? IndLogo
                    : OrgLogo)
                }
                alt="profile"
              />
            </div>
            <div className="profile-details">
              <h2 className="profile-name">
                {userData?.user?.profileType === "admin" ||
                userData?.user?.profileType === "individual"
                  ? `${userData?.user?.firstName} ${userData?.user?.lastName}`
                  : userData?.user?.businessName}
              </h2>
              <div className="profile-badges">
                <span className="user-type-badge">
                  {userData?.user?.profileType === "impactOrg" 
                    ? "IMPACT ORG" 
                    : userData?.user?.profileType?.toUpperCase()}
                </span>
                <span className="referral-badge">
                  REFERRAL CODE: {userData?.user?.referCode}
                </span>
                {userData?.user?.profileType !== "individual" && (
                  <span className="poc-badge">
                    POC: {`${userData?.user?.firstName} ${userData?.user?.lastName}`}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="referral-section">
            <h3 className="referral-title">Share the Referral Link</h3>
            <div className="referral-input-group">
              <input
                type="text"
                className="referral-input"
                disabled
                value={`https://demo.donor.money/register?referredby=${userData?.user?.referCode}`}
              />
              <div className="referral-actions">
                <button className="action-icon" onClick={handleCopy} title="Copy">
                  <MdContentCopy size={28} />
                </button>
                <button className="action-icon" onClick={handleMail} title="Email">
                  <IoMail size={28} />
                </button>
                <button className="action-icon" onClick={handleWp} title="WhatsApp">
                  <IoLogoWhatsapp size={28} />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Balance and Actions Section */}
        <div className="balance-section">
          <div className="balance-info">
            <div className="balance-card">
              <h3 className="balance-title">Balance</h3>
              <div className="balance-amount">
                ${(userData?.wallet?.walletPoint * currency?.value)?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </div>
              <div className="exchange-rate">
                (1.000 DM = ${currency?.value?.toFixed(2)})
              </div>
            </div>
            <div className="dm-card">
              <h3 className="dm-title">Donor Money</h3>
              <div className="dm-amount">
                {userData?.wallet?.walletPoint?.toLocaleString(undefined, {
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3,
                })} DM
              </div>
            </div>
            <div
              className="dm-card"
              onClick={() => setShowSirRewards(true)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setShowSirRewards(true);
                }
              }}
              role="button"
              tabIndex={0}
              aria-label="View SIR rewards"
            >
              <h3 className="dm-title">SIR Reward</h3>
              <div className="dm-amount">
                {totalSirRewards.toLocaleString(undefined, {
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3,
                })}{" "}
                tokens
              </div>
            </div>
          </div>
          {profile !== "view_access" && (
          <div className="action-buttons">
            <button className="btn-primary" onClick={openSend}>
              Give DM
            </button>
            <button className="btn-secondary" onClick={openModal}>
              Edit Profile
            </button>
          </div>
          )}
        </div>

        {/* Transactions Section */}
        <div className="transactions-section">
          <h2 className="section-title">Recent Transactions</h2>
          
          <div className="filters-container">
            <div className="filter-group">
              <select
                className="filter-select"
                onChange={(e) => setFilter({ ...filter, status: e.target.value })}
                value={filter.status}
              >
                <option value="">All Status</option>
                <option value="success">Success</option>
                <option value="failed">Failed</option>
                <option value="reversed">Reversed</option>
              </select>

              <select
                className="filter-select"
                onChange={(e) => setFilter({ ...filter, type: e.target.value })}
                value={filter.type}
              >
                <option value="">All Types</option>
                <option value="Donation">Donation</option>
                <option value="Grant">Grant</option>
                <option value="Sale">Sale</option>
                <option value="Purchase">Purchase</option>
                <option value="Barter">Barter</option>
                <option value="Gift">Gift</option>
              </select>

              <button className="sort-button" onClick={toggleSortByDate}>
                Sort by Date {sortByDate === "asc" ? "↓" : "↑"}
              </button>
            </div>
          </div>

          <div className="transactions-table-container">
            <table className="transactions-table" style={{ textAlign: "left" }}>
              <thead>
                <tr>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Date</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>ID</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>From</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>To</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Amount (DM)</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Market Value</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Type</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Status</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Payment Mode</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentTransactions
                  ?.sort((a, b) => {
                    const dateA = moment(a.createdDate);
                    const dateB = moment(b.createdDate);
                    return sortByDate === "asc" ? dateA - dateB : dateB - dateA;
                  })
                  .map((tr, index) => (
                    <tr key={index} className="transaction-row">
                      <td className="date-cell" style={{ textAlign: "left" }}>
                        {moment(tr.createdDate).format("DD-MMM-YYYY hh:mm A")}
                      </td>
                      <td className="id-cell" style={{ textAlign: "left" }}>{tr.transId ? tr.transId : tr._id}</td>
                      <td 
                        className="user-cell clickable"
                        style={{ textAlign: "left" }}
                        onClick={() => tr.senderId && handleView(tr.senderId)}
                      >
                        {tr.senderId?.businessName
                          ? tr.senderId?.businessName
                          : `${tr.senderId?.firstName} ${tr.senderId?.lastName}`}
                      </td>
                      <td 
                        className="user-cell clickable"
                        style={{ textAlign: "left" }}
                        onClick={() => tr.recipientUserId && handleView(tr.recipientUserId)}
                      >
                        {tr.recipientUserId?.businessName
                          ? tr.recipientUserId?.businessName
                          : `${tr.recipientUserId?.firstName} ${tr.recipientUserId?.lastName}`}
                      </td>
                      <td className="amount-cell" style={{ textAlign: "left" }}>
                        {tr.amount?.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}
                      </td>
                      <td className="value-cell" style={{ textAlign: "left" }}>
                        ${(tr.amount * tr.currencyValue)?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) || 0}
                      </td>
                      <td className="type-cell" style={{ textAlign: "left" }}>{tr.transactionType}</td>
                      <td className="status-cell" style={{ textAlign: "left" }}>
                        <span className={`status-badge ${tr.transactionStatus}`}>
                          {capitalizeFirstLetter(tr.transactionStatus)}
                        </span>
                      </td>
                      <td className="payment-cell" style={{ textAlign: "left" }}>{tr.paymentMode}</td>
                      <td className="action-cell" style={{ textAlign: "left" }}>
                        {profile !== "view_access" &&
                          tr.transactionStatus !== "reversed" &&
                          !tr.isReversed &&
                          tr.transactionStatus !== "failed" && (
                            <button 
                              className="reverse-button"
                              onClick={() => sendBack(tr)}
                            >
                              Reverse
                            </button>
                          )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>

            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={Math.ceil(userData?.transactions?.length / transactionsPerPage)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          </div>
        </div>

        <div className="disclaimer">
          <p>
            *Market Value is based on the last traded price on the Donor Money{" "}
            <a href="https://www.donor.money/Impact-Exchange" target="_blank" rel="noopener noreferrer">
              Impact Funding Exchange
            </a>
          </p>
        </div>
      </div>
      <AddCoins
        showModal={showSend}
        closeModal={closeSend}
        userDetails={userData}
        userToken={userToken}
      />
      <EditUserModal
        userId={userData.user?._id}
        userToken={userToken}
        onClose={closeModal}
        showEdit={showEdit}
        isAdmin={true}
      />
      <ShowSirRewards
        showModal={showSirRewards}
        closeModal={() => {
          setShowSirRewards(false);
          loadSirRewardTotal();
        }}
        userId={ngoId}
        userToken={userToken}
        canReverse={profile !== "view_access"}
      />
      <Footer />
    </>
  );
};

export default Ngo;
